(function () {
  function run() {
    const endpointUrl = 'https://laapparel.co/main/laa/shopify/sliders/';
    const container = document.getElementById('slider-container');
    if (!container) return;

    /* ===================== Feature toggles ===================== */
    const GEO_FEATURE_ENABLED = false; // keep false unless needed
    const TRI_STATE_EXCLUSIVE_POSITIONS = new Set([1]);

    // Always shuffle non-pinned slides on every refresh
    const RANDOMIZE_EVERY_REFRESH = true;

    /* -------------------- GEO (IP2Location.io) with CACHING -------------------- */
    const TRI = new Set(['NY', 'NJ', 'CT']);
    const NAME2CODE = { 'New York': 'NY', 'New Jersey': 'NJ', 'Connecticut': 'CT' };
    const IP2L_URL = 'https://api.ip2location.io/?format=json&key=0B085147F04DD75F5561EB47E4739931';

    const GEO_CACHE_KEY = 'laa_geo_cache';
    const GEO_CACHE_DURATION = 24 * 60 * 60 * 1000;

    function getGeoCache() {
      try {
        const cached = localStorage.getItem(GEO_CACHE_KEY);
        if (!cached) return null;
        const data = JSON.parse(cached);
        if (Date.now() - data.timestamp > GEO_CACHE_DURATION) {
          localStorage.removeItem(GEO_CACHE_KEY);
          return null;
        }
        return !!data.isTriState;
      } catch {
        localStorage.removeItem(GEO_CACHE_KEY);
        return null;
      }
    }

    function setGeoCache(isTriState) {
      try {
        localStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ isTriState: !!isTriState, timestamp: Date.now() }));
      } catch { }
    }

    async function isTriStateVisitor() {
      if (!GEO_FEATURE_ENABLED) return false;

      const qp = new URL(location.href).searchParams;
      const ov = qp.get('state');
      if (ov) {
        const isTriState = TRI.has(ov.trim().toUpperCase());
        setGeoCache(isTriState);
        return isTriState;
      }

      const cached = getGeoCache();
      if (cached !== null) return cached;

      try {
        const ctrl = new AbortController();
        const to = setTimeout(() => ctrl.abort(), 3000);
        const res = await fetch(IP2L_URL, { signal: ctrl.signal, cache: 'no-store' });
        clearTimeout(to);
        if (!res.ok) throw new Error('geo fetch failed');
        const data = await res.json();

        let isTriState = false;
        if (data && data.country_code === 'US' && typeof data.region_name === 'string') {
          const code = NAME2CODE[data.region_name] || null;
          isTriState = !!(code && TRI.has(code));
        }

        setGeoCache(isTriState);
        return isTriState;
      } catch {
        setGeoCache(false);
        return false;
      }
    }
    /* --------------------------------------------------------------- */

    function isDesktop() {
      return window.matchMedia && window.matchMedia('(min-width: 1024px)').matches;
    }

    function shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    }

    async function fetchFresh(url) {
      // Cache buster so you get a fresh randomized payload on every refresh
      const bust = (url.includes('?') ? '&' : '?') + '_=' + Date.now();
      const res = await fetch(url + bust, {
        cache: 'no-store',
        credentials: 'omit'
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return await res.json();
    }

    /* Payload strategy: slide order is shuffled CLIENT-side on every render,
       so a session-cached payload loses no variety. Repeat views render
       instantly from sessionStorage while a background fetch refreshes the
       cache; first view uses the early fetch started inline in the section. */
    const SLIDER_CACHE_KEY = 'laa_slider_payload';

    function readPayloadCache() {
      try {
        return JSON.parse(sessionStorage.getItem(SLIDER_CACHE_KEY));
      } catch {
        return null;
      }
    }

    function writePayloadCache(payload) {
      try { sessionStorage.setItem(SLIDER_CACHE_KEY, JSON.stringify(payload)); } catch { }
    }

    function getPayload() {
      const early = window.__laaSliderFetch;
      window.__laaSliderFetch = null;
      const network = (early || fetchFresh(endpointUrl)).then(payload => {
        writePayloadCache(payload);
        return payload;
      });
      network.catch(() => { });

      const cached = readPayloadCache();
      if (cached) return Promise.resolve(cached);
      return network;
    }

    /* -------------------- Flickity state/options -------------------- */
    let flkty;

    const flickityOptions = {
      cellSelector: '.carousel__cell, .carousel__cell_video',
      pageDots: false,
      freeScroll: false,
      wrapAround: true,
      autoPlay: 8000,
      cellAlign: 'left',
      contain: true,
      pauseAutoPlayOnHover: false,
      /* Snappier slide animation (defaults 0.025/0.28 feel floaty and slow) */
      selectedAttraction: 0.055,
      friction: 0.35,
      lazyLoad: 2,
      adaptiveHeight: true,
      imagesLoaded: true,
      dragThreshold: 5,
      initialIndex: 0,
      percentPosition: true,
      groupCells: false,
      arrowShape:
        "M100,38.4L39.9,38.4L79,0L50,0L0,50L50,100L79,100L39.9,61.6L100,61.6Z"
    };

    function ensureVideoLoaded(videoEl) {
      if (!videoEl) return;

      // Works whether you use data-src OR src
      const srcEl = videoEl.querySelector('source[data-src]');
      if (srcEl && !srcEl.src) {
        srcEl.src = srcEl.dataset.src;
        try { videoEl.load(); } catch { }
      }
    }

    function pauseAllVideos() {
      container.querySelectorAll('video').forEach(v => {
        try { v.pause(); } catch { }
      });
    }

    function playVideo(videoEl) {
      if (!videoEl) return;

      // Safari/iOS: set BOTH properties + attributes
      videoEl.muted = true;
      videoEl.loop = true;
      videoEl.playsInline = true;

      videoEl.setAttribute('muted', '');
      videoEl.setAttribute('loop', '');
      videoEl.setAttribute('playsinline', '');

      ensureVideoLoaded(videoEl);

      const tryPlay = () => {
        const p = videoEl.play();
        if (p && typeof p.catch === 'function') p.catch(() => { });
      };

      // If not ready, wait for canplay
      if (videoEl.readyState >= 2) {
        tryPlay();
      } else {
        videoEl.addEventListener('canplay', tryPlay, { once: true });
      }
    }

    function preloadVideoInCell(cellEl) {
      const v = cellEl && cellEl.querySelector('video');
      if (!v) return;
      ensureVideoLoaded(v);
    }

    function handleVisibleSlideMedia() {
      if (!flkty || !flkty.cells.length) return;

      // Pause everything first
      pauseAllVideos();

      // Play videos in ALL currently visible cells:
      // - selected
      // - next visible on desktop (2-up)
      const idxs = [flkty.selectedIndex];
      if (isDesktop() && flkty.cells.length > 1) idxs.push((flkty.selectedIndex + 1) % flkty.cells.length);

      idxs.forEach(i => {
        const cellEl = flkty.cells[i]?.element;
        const v = cellEl && cellEl.querySelector('video');
        if (!v) return;

        // ensure attrs + source are correct
        v.loop = true;
        v.muted = true;
        v.playsInline = true;
        v.autoplay = true;
        v.setAttribute('loop', '');
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('autoplay', '');

        playVideo(v);

        v.addEventListener('loadedmetadata', () => {
          try { flkty.resize(); } catch { }
        }, { once: true });
      });
    }

    function initializeFlickity() {
      if (!window.Flickity) {
        console.warn('Flickity not loaded yet.');
        return;
      }

      const existing = window.Flickity.data(container);
      if (existing) existing.destroy();

      flkty = new window.Flickity(container, flickityOptions);

      flkty.on('ready', () => {
        handleVisibleSlideMedia();
        flkty.resize();
      });

      flkty.on('select', () => {
        handleVisibleSlideMedia();
      });

      flkty.on('settle', () => {
        handleVisibleSlideMedia();
      });

      container.addEventListener(
        'load',
        e => {
          if (e.target && e.target.tagName === 'IMG' && flkty) flkty.resize();
        },
        true
      );
    }

    /* -------------------- Build ordered cell list -------------------- */
    function buildCellsFromPayload(items) {
      // Flatten sliders into individual cells but carry slider_position
      const cells = [];
      items.forEach(slider => {
        const url = slider.page_url || slider.collection_url || slider.product_url || '';
        const posNum = Number(slider?.slider_position);
        const pinnedPos = Number.isFinite(posNum) && posNum >= 1 ? posNum : null;

        if (Array.isArray(slider.images)) {
          slider.images.forEach(img => cells.push({ type: 'image', url, img, pinnedPos }));
        }
        if (Array.isArray(slider.videos)) {
          slider.videos.forEach(video => cells.push({ type: 'video', url, video, pinnedPos }));
        }
      });
      return cells;
    }

    function orderCellsWithPinnedPositions(cells) {
      const pinnedMap = new Map(); // pos -> [cells...]
      const unpinned = [];

      cells.forEach(c => {
        if (c.pinnedPos) {
          if (!pinnedMap.has(c.pinnedPos)) pinnedMap.set(c.pinnedPos, []);
          pinnedMap.get(c.pinnedPos).push(c);
        } else {
          unpinned.push(c);
        }
      });

      if (RANDOMIZE_EVERY_REFRESH) shuffle(unpinned);

      const pinnedPositions = Array.from(pinnedMap.keys()).sort((a, b) => a - b);
      const maxPos = pinnedPositions.length ? pinnedPositions[pinnedPositions.length - 1] : 0;

      const out = [];
      let poolIdx = 0;

      // Fill absolute slots 1..maxPos, injecting pinned where defined,
      // otherwise pulling from randomized pool.
      for (let slot = 1; slot <= maxPos; slot++) {
        const pins = pinnedMap.get(slot);
        if (pins && pins.length) {
          out.push(...pins);
        } else if (poolIdx < unpinned.length) {
          out.push(unpinned[poolIdx++]);
        }
      }

      // Append remaining randomized
      while (poolIdx < unpinned.length) out.push(unpinned[poolIdx++]);

      // If there were no pinned slots, it's just randomized pool
      if (!maxPos) return unpinned;

      return out;
    }

    /* -------------------- Render cells -------------------- */
    function renderCells(cells) {
      container.innerHTML = '';
      container.classList.remove('slider--loading');
      container.removeAttribute('aria-busy');

      const frag = document.createDocumentFragment();

      const eagerCount = isDesktop() ? 2 : 1;
      let cellIndex = 0;

      const buildImg = (img, eager, isLcpCandidate) => {
        const sizes = '(min-width: 1024px) 50vw, 100vw';
        const base =
          `alt="${img.alt || ''}" class="carousel-cell-image img-fluid d-md-block" ` +
          `width="1400" height="933" decoding="async"` +
          (img.srcset ? ` sizes="${sizes}"` : '');

        if (eager) {
          const pr = isLcpCandidate ? 'high' : 'auto';
          const srcset = img.srcset ? `srcset="${img.srcset}"` : '';
          return `<img ${srcset} src="${img.src}" loading="eager" fetchpriority="${pr}" ${base} />`;
        }

        return `<img
          data-flickity-lazyload-srcset="${img.srcset || ''}"
          data-flickity-lazyload="${img.src}"
          loading="lazy"
          fetchpriority="low"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          ${base}
        />`;
      };

      cells.forEach(cell => {
        const cellEl = document.createElement('div');

        if (cell.type === 'image') {
          const eager = cellIndex < eagerCount;
          const isLcpCandidate = cellIndex === 0;

          cellEl.className = 'carousel__cell';
          const imgMarkup = buildImg(cell.img, eager, isLcpCandidate);

          cellEl.innerHTML = cell.url
            ? `<a class="cell" href="${cell.url}">${imgMarkup}</a>`
            : `<div class="cell">${imgMarkup}</div>`;

          frag.appendChild(cellEl);
          cellIndex++;
          return;
        }

        if (cell.type === 'video') {
          // IMPORTANT: keep your original structure (wrapper has .video__container)
          const poster = cell.video.poster ? ` poster="${cell.video.poster}"` : '';

          cellEl.className = 'carousel__cell carousel__cell_video';

          // We keep data-src for all videos, but we will preload the first visible ones immediately after render.
          const videoMarkup = `
              <video playsinline muted loop autoplay preload="metadata"${poster}>
                <source data-src="${cell.video.src}" type="video/mp4" />
              </video>
            `;

          cellEl.innerHTML = cell.url
            ? `<a class="cell video__container" href="${cell.url}">${videoMarkup}</a>`
            : `<div class="cell video__container">${videoMarkup}</div>`;

          frag.appendChild(cellEl);
          cellIndex++;
        }
      });

      container.appendChild(frag);

      // Preload source for initially visible slides BEFORE Flickity init
      const eagerVideoCount = isDesktop() ? 2 : 1;
      const initialVideos = Array.from(container.querySelectorAll('video')).slice(0, eagerVideoCount);
      initialVideos.forEach(v => ensureVideoLoaded(v));
    }

    /* -------------------- Load → order → render → init -------------------- */
    async function loadAndBuild(isTriState) {
      let items = [];
      try {
        const payload = await getPayload();
        items = Array.isArray(payload?.sliders) ? payload.sliders : (Array.isArray(payload) ? payload : []);
      } catch (e) {
        console.error('Failed to load sliders:', e);
        container.textContent = 'Error loading content.';
        return false;
      }

      // Geo filtering only when enabled
      if (GEO_FEATURE_ENABLED && !isTriState) {
        items = items.filter(s => !TRI_STATE_EXCLUSIVE_POSITIONS.has(Number(s?.slider_position)));
      }

      const cells = buildCellsFromPayload(items);
      const ordered = orderCellsWithPinnedPositions(cells);
      renderCells(ordered);
      return true;
    }

    (async () => {
      const isTriState = await isTriStateVisitor();
      const ok = await loadAndBuild(isTriState);
      if (!ok) return;
      requestAnimationFrame(initializeFlickity);
    })();

    // Resize: re-init only if width changes a lot
    let lastWidth = window.innerWidth;
    const threshold = 120;
    window.addEventListener('resize', () => {
      const w = window.innerWidth;
      if (Math.abs(w - lastWidth) >= threshold) {
        initializeFlickity();
        lastWidth = w;
      } else if (flkty) {
        flkty.resize();
      }
    });

    document.addEventListener('shopify:section:load', initializeFlickity);
    document.addEventListener('shopify:section:select', initializeFlickity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
